import * as React from 'react';
import { observer } from 'mobx-react';

import { DataTableView } from 'src/core/ui/data-table.view';
import { Button, Modal } from 'antd';
import { UserTaskFormController } from 'src/app/general/user-tasks/form/user-task.controller';
import { UserTasksListController } from 'src/app/general/user-tasks/list/user-tasks.list.controller';
import { IdentityService } from 'src/core/services/identity.service';
import { resolve } from 'inversify-react';
import * as Permissions from '../../../permissions';
import { UserTaskSummariesDataService } from 'src/app/general/user-tasks/list/user-task-list.data';
import { CollapseCard } from 'src/app/shared/collapse-card.view';

interface Props {
	modelType?: string;
	modelId?: any;
	setBusy(isBusy: boolean);
	kanban?: boolean;
	title?: string;
	extraFilter?: (dataService: UserTaskSummariesDataService) => void;
	onLoad?: (data: UserTaskSummary[]) => void;
	daedline?: Date;
	assignedToId?: number;
	priority?: number;
	titleTask?: string;
	useLoginFilter:boolean
}

interface State {
	modalOpen: boolean;
	taskId?: number;
}

@observer
export class AddUserTaskView extends React.Component<Props, State> {

	constructor(props: Readonly<Props>) {
		super(props);
		this.state = {
			modalOpen: false
		}
	}

	@resolve
	identityService: IdentityService;

	private isAuthorized(permissions: string[]): boolean {
		return permissions.some(m => this.identityService.isAuthorized(m));
	}

	onCancel = () => {
		this.handleModal();
		this.setState({ taskId: undefined });
	}

	onEdit = () => {


		if (this.list)
			this.list.reload();

		this.setState({ taskId: undefined });
	}

	handleModal = () => {
		this.setState({ modalOpen: !this.state.modalOpen });

	}

	list: any;

	render() {

		
		const canChangeAssignment = this.isAuthorized(Permissions.userTaskWriteAssignment);
		const canChangeDeadline = this.isAuthorized(Permissions.userTaskWriteDeadline);
		const canChangeStatus = this.isAuthorized(Permissions.userTaskWriteStatus);
		const canChangeTitle = this.isAuthorized(Permissions.userTaskWriteTitle);
		const canChangePriority = this.isAuthorized(Permissions.userTaskWritePriority)
		const canAdd = this.isAuthorized(Permissions.userTaskWrite) && canChangeAssignment && canChangeDeadline && canChangeStatus && canChangeTitle && canChangePriority;
		return (
			<CollapseCard
				title={this.props.title || "Your tasks"}
			>
				<div className="p-3">
					{this.state.modalOpen && <UserTaskFormController
						{...this.props}
						title={this.props.titleTask}
						visible={this.state.modalOpen}
						id={this.state.taskId}
						onFinish={this.onCancel}
						onEdit={this.onEdit}
					/>}
					{canAdd && this.props.modelId && this.props.modelType && <Button style={{ marginBottom: '10px' }} type='primary' onClick={this.handleModal}>Add user task</Button>}

					<UserTasksListController
						{...this.props}
						onLoad={this.props.onLoad}
						ref={e => this.list = e}
						kanban={this.props.kanban}
						extraFilter={this.props.extraFilter}
						onEdit={(e) => {
							console.log(e);
							this.setState({ taskId: e, modalOpen: true })
						}}
					/>
				</div>
			</CollapseCard>
		);
	}
}



// WEBPACK FOOTER //
// ./src/app/general/user-tasks/parts/add-user-tasks.view.tsx